import { MARITAL_STATUS, OPTION_VALUES, PaymentOptionName } from "@ipru-common/constants/InputValues";
import { LMS_CONSTANTS } from "@ipru-common/constants/SiteConstants";
import { PRODUCT_CODES, PRODUCT_NAMES } from "@ipru-common/constants/products";
import GlobalStore from "@ipru-common/store/GlobalStore";
import { getCiTerm } from "../QuoteCommonFunctions";
import { convertToISODate, currencyToWord, readQueryParams } from "../CommonFunctions";
import _ from "lodash";

const getICARENetCoreInput = () => {
  const { quoteFormData, calculatorFormData, existingCustomer, currentPageStep, appFormData } =
    GlobalStore.getSnapshot();
  const queryParams = readQueryParams();

  const urlParams = new URLSearchParams(window?.location?.search);
  const params = Object.fromEntries(urlParams?.entries());

  const getCurrentTimeStamp = () => {
    const time = new Date();

    const day = String(time.getDate()).padStart(2, "0");
    const month = String(time.getMonth() + 1).padStart(2, "0");
    const year = time.getFullYear();

    const hours = String(time.getHours()).padStart(2, "0");
    const minutes = String(time.getMinutes()).padStart(2, "0");
    const seconds = String(time.getSeconds()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  const getAppFormStep = () => {
    let result = 1;
    if (!appFormData?.appNO) {
      result = 1;
    } else {
      if (appFormData?.stepsCleared?.personalDetails && !appFormData?.stepsCleared?.nomineeDetails) {
        result = 2;
      } else if (appFormData?.stepsCleared?.nomineeDetails && !appFormData?.stepsCleared?.healthDetails) {
        result = 3;
      } else if (appFormData?.stepsCleared?.healthDetails) {
        result = 4;
      }
    }
    return result;
  };

  const pptSavingsData = quoteFormData?.savings?.[quoteFormData?.paymentOption]?.split(" ");
  const pptSaving = pptSavingsData?.[0]?.replace(/₹/g, "").replace(/,/g, "").trim() || 0;
  const pptSavingPercent = pptSavingsData?.[1]?.replace(/[()]/g, "").trim() || 0;

  let ipsUserInputs = {
    age: calculatorFormData?.age,
    dob: convertToISODate(calculatorFormData?.user_dob),
    gender: calculatorFormData?.gender,
    staff: calculatorFormData?.staff === OPTION_VALUES.STAFF_N ? OPTION_VALUES.N_NO : OPTION_VALUES.Y_YES,
    term: quoteFormData?.term || 0,
    mobileno: parseInt(calculatorFormData?.mobileno) || "",
    emailid: calculatorFormData?.emailid,
    annualincome: parseInt(calculatorFormData?.yr_income),
    occupation: calculatorFormData?.calc_occupation,
    city: calculatorFormData?.city,
    qdata: queryParams?.get("qdata") || "",
    usetobacco: calculatorFormData?.tobacco,
    citerm:
      getCiTerm(quoteFormData?.paymentOption, calculatorFormData?.age, quoteFormData?.ppt, quoteFormData?.term) || 0,
    adbterm: _.min([quoteFormData?.term, 80 - parseInt(calculatorFormData?.age)]) || 0,
    premiumpaymentoption: PaymentOptionName[quoteFormData?.paymentOption],
    sumassured: quoteFormData?.lumpSumAmt || 0,
    payoutoptions: LMS_CONSTANTS[quoteFormData?.payoutType],
    paymentfrequency: LMS_CONSTANTS[quoteFormData?.tenure],
    plan: `${quoteFormData?.planType?.charAt(0).toUpperCase()}${quoteFormData?.planType?.slice(1)}`,
    premium: quoteFormData?.breakupDetail?.total || 0,
    whatsapp_optin: quoteFormData?.wth_option ? "Yes" : "No",
    step: currentPageStep != "appFormScreen" ? "step1" : `step${getAppFormStep()}`,
    education: calculatorFormData?.calc_education,
    state: calculatorFormData?.state,
    pincode: parseInt(calculatorFormData?.pincode) || "",
    nri: calculatorFormData?.nri,
    nrifullname: "",
    nrimoblieno: parseInt(calculatorFormData?.mobileno) || "",
    nriemail: "",
    livinginindia: calculatorFormData?.is_nri_in_india ? OPTION_VALUES.NRI_YES : OPTION_VALUES.NRI_NO,
    nriarrivingdate: convertToISODate(calculatorFormData?.nri_india_arriving_date),
    exitpopup: calculatorFormData?.pri_frst_nm?.length > 0 ? "t" : "f",
    fullname: appFormData?.formWizard?.personalDetails?.full_name || "f",
    flag_partner: calculatorFormData?.pasa || "f",
    pagename: LMS_CONSTANTS.IPS_PAGE_NAME,
    uid: "",
    sumassured2: currencyToWord(quoteFormData?.lumpSumAmt),
    existing_cust: calculatorFormData?.employeeId || existingCustomer ? "Yes" : "No",
    schedulecalltimestamp: "",
    fname: "",
    lname: "",
    isnri: calculatorFormData?.nri === OPTION_VALUES.Y_YES ? OPTION_VALUES.TRUE : OPTION_VALUES.FALSE,
    lms_nri: calculatorFormData?.nri,
    income_date: "",
    p_gender: "",
    p_dob: "",
    getincome: "",
    trai: OPTION_VALUES.TRUE,
    modalpremium: "",
    paymentoption: quoteFormData?.paymentOption,
    payoutterm: quoteFormData?.term,
    relation: "",
    policyterm: quoteFormData?.term,
    incomemode: quoteFormData?.tenure,
    mode: quoteFormData?.tenure,
    income_frequency: quoteFormData?.tenure,
    rideroptionadded: "",
    pensionfrequency: "",
    lifecover: quoteFormData?.SA,
    payout: quoteFormData?.payoutType,
    productid: PRODUCT_CODES.iProtectCare,
    invest_type: "",
    invest_strat: "",
    iswop: "",
    wop_selctedoption: "",
    rider1: "",
    rider2: "",
    rider3: "",
    propdob: "",
    propgender: "",
    p_age: "",
    cdob: "",
    cage: "",
    name: "",
    crelation: "",
    cgender: "",
    appointeegender: "",
    appointeerelation: appFormData?.formWizard?.nomineeDetails?.appointee_relationship || "",
    iswhatsappopted: "",
    propage: "",
    payfor: "",
    paymentfreq: "",
    dobspouse: "",
    spouseeducation: OPTION_VALUES.EDUCATION.GRADUATE,
    spouseoccupation: OPTION_VALUES.OCCUPATION.HOUSEWIFE,
    spousetobacco: OPTION_VALUES.N_NO,
    ishousewife: calculatorFormData.calc_occupation === OPTION_VALUES.OCCUPATION.HOUSEWIFE ? "t" : "f",
    brochure_selected: "",
    tollfree_selected: "",
    isandroid: "",
    isios: "",
    channel: quoteFormData?.channel,
    accidental_death_benefit: quoteFormData?.ADB_SA || 0,
    critical_illness_benefit: quoteFormData?.CI_SA || 0,
    firstname: "",
    lastname: "",
    trai_flag: calculatorFormData?.trai_flag ? OPTION_VALUES.Y_YES : OPTION_VALUES.N_NO,
    trai_flag_sm: OPTION_VALUES.N_NO,
    annual_income: parseInt(calculatorFormData?.yr_income),
    nominee: appFormData?.formWizard?.nomineeDetails?.nominee_first_name || "",
    timestamp: getCurrentTimeStamp(),
    residential_sts: "",
    appno: appFormData?.appNO,
    mrt_sts: MARITAL_STATUS[appFormData?.formWizard?.personalDetails?.marital_status] || "",
    countrycode: calculatorFormData?.country_code,
    countryname: calculatorFormData?.country_of_residence,
    persona: params?.persona || "",
    language: params?.lan || "",
    premiumwithci: quoteFormData?.breakupDetail?.base + quoteFormData?.breakupDetail?.ciPremium,
    martialstatus: MARITAL_STATUS[appFormData?.formWizard?.personalDetails?.marital_status] || "",
    plan_for: "",
    relations: "",
    salaried: "",
    productname: PRODUCT_NAMES.iProtectCare,
    ind_flag_nri: "",
    internationalmobileno: "",
    travelinlast1year: appFormData?.formWizard?.personalDetails?.travelled_abroad || "",
    lms_gender: calculatorFormData?.gender,
    latname: "",
    diabetes: quoteFormData?.isDiabetic === 1 ? OPTION_VALUES.Y_YES : OPTION_VALUES.N_NO,
    isEnglish: params?.lan === "hi" ? "FALSE" : "TRUE",
    ppt: quoteFormData?.ppt || 0,
    partnerdetails: "",
    nriindianpincodecity: "",
    married: "",
    spousedetails: "",
    currentPageStep: currentPageStep,
    nreflag: "",
    nroflag: "",
    wantgstflag: appFormData?.formWizard?.personalDetails?.nri_gst_waiver || "",
    lead_type: currentPageStep != "appFormScreen" ? "Lead" : "Drop",
    page_name: LMS_CONSTANTS.IPRIME_PAGE_NAME,
    maritalstatus: MARITAL_STATUS[appFormData?.formWizard?.personalDetails?.marital_status] || "",
    pensionfor: "",
    purchasefor: "",
    spouse_dob: "",
    spouse_age: "",
    spouse_name: "",
    nps_flag: OPTION_VALUES.FALSE,
    keyword: "",
    incomebenefit: "",
    max_term: "",
    occ: appFormData?.formWizard?.occupationDetails?.my_profession || "",
    appdropoff: "",
    next_year_premium: quoteFormData?.breakupDetail?.onSecondYearPremium || 0,
    next_year_monthly_premium: quoteFormData?.breakupDetail?.total || 0,
    next_year_yearly_premium: quoteFormData?.breakupDetail?.annualPremium || 0,
    address: `${appFormData?.formWizard?.personalDetails?.address_line_1 || ""} ${appFormData?.formWizard?.personalDetails?.address_line_2 || ""
      } ${appFormData?.formWizard?.personalDetails?.address_line_3 || ""} ${appFormData?.formWizard?.personalDetails?.landmark || ""
      }`
      .replaceAll(/\s+/g, " ")
      .trim(),
    leadflag: "",
    PFP_PK_ID: "", // use for token
    PRI_MEDICAL_DATE: "", //IP address

    //new Added
    critical_illness_benefit_1:
      quoteFormData?.ciMode === OPTION_VALUES.CI_MODES.COMPREHENSIVE.years ? quoteFormData?.CI_SA : 0,
    critical_illness_benefit_2:
      quoteFormData?.ciMode === OPTION_VALUES.CI_MODES.CLASSIC.years ? quoteFormData?.CI_SA : 0,
    premium_break: "",
    accidental_disability_benefit: quoteFormData?.breakupDetail?.adbPremium,
    ppt_savings_with_gst: pptSaving,
    ppt_savings_percent_with_gst: pptSavingPercent,
    ppt_savings: pptSaving,
    ppt_savings_percent: pptSavingPercent,
    female_discount_percent: quoteFormData?.breakupDetail?.femaleDiscountPercent,
    salaried_percent: quoteFormData?.breakupDetail?.salariedDiscountPercent,
    online_discount: quoteFormData?.breakupDetail?.onlineDiscount,
    female_discount_percent_gst: quoteFormData?.breakupDetail?.femaleDiscountPercent,
    salaried_percent_gst: quoteFormData?.breakupDetail?.salariedDiscountPercent,
    online_discount_gst: quoteFormData?.breakupDetail?.onlineDiscount,
    female_discount_percent_without_gst: quoteFormData?.breakupDetail?.femaleDiscountPercent,
    salaried_percent_without_gst: quoteFormData?.breakupDetail?.salariedDiscountPercent,
    online_discount_without_gst: quoteFormData?.breakupDetail?.onlineDiscount,
    smart_exit_eligible: quoteFormData?.eligibleForSmartExit?.eligible,
    smart_exit_age_1: "",
    smart_exit_age_2: "",
    smart_exit_age_3: "",
    ci_cover_gst: quoteFormData?.CI_SA || 0,
    adb_cover_gst: quoteFormData?.ADB_SA || 0,
    ci_cover_without_gst: quoteFormData?.CI_SA || 0,
    adb_cover_without_gst: quoteFormData?.ADB_SA || 0,
    db_payout_savings_amount_gst: "",
    db_payout_savings_percent_gst: "",
    db_payout_savings_amount: "",
    db_payout_savings_percent: "",
    premium_3years_gst: "",
    premium_5years_gst: "",
    premium_3years: "",
    premium_5years: "",
    gst_waiver: appFormData?.formWizard?.personalDetails?.nri_gst_waiver || "",
    premium_without_gst: "",
    total_gst: quoteFormData?.breakupDetail?.totalGst,
    adterm: "",
    nreflag_1: "",
    nroflag_1: "",
    Smart_Exit_Entry: quoteFormData?.entryAge,
    Smart_Exit_Out: quoteFormData?.upperAge,
    Cover_Till_Age: quoteFormData?.coverTillAge,
  };

  return ipsUserInputs;
};

export default getICARENetCoreInput;
